import { Action } from '@ngrx/store';
import { ExportMetadata } from '@deltager/organizers/admin/shared/components/export/export.component';
import {
  DntStorableTableConfig,
} from '@deltager/organizers/admin/modules/events/events-list-main/dnt-events-list/store/dnt-events-list.state';
import {
  DntPrimaryFilter,
} from '@deltager/organizers/admin/modules/events/events-list-main/dnt-events-list/models/dnt-list-filter-form-group.model';

export enum DntEventsListActionTypes {
  // Triggered by table.component
  InitialFilterParsedFromQueryString = '[Dnt events list]: Initial filter was parsed from query string.',
  ExportableTableConfigsChanged = '[Dnt events list]: Exportable table configuration changed.',
  LoadingChanged = '[Dnt events list]: loading changed.',

  // Triggered by filter.component
  CoreFiltersChanged = '[Dnt events list]: Core filters changed.',
  ExportReportRequested = '[Dnt events list]: Export report was requested.',
  FiltersCleared = '[Dnt events list]: Filters were cleared.',

  // Triggered by auth.service
  ResetFilters = '[Dnt events list]: Filters were reset due to organizer change.',
}

export class InitialFilterParsedFromQueryStringAction implements Action {
  readonly type = DntEventsListActionTypes.InitialFilterParsedFromQueryString;

  constructor(public readonly filters: DntPrimaryFilter) {
  }
}

export class ExportableTableConfigsChangedAction implements Action {
  readonly type = DntEventsListActionTypes.ExportableTableConfigsChanged;

  constructor(public readonly payload: DntStorableTableConfig) {
  }
}

export class LoadingChangedAction implements Action {
  readonly type = DntEventsListActionTypes.LoadingChanged;

  constructor(public readonly payload: boolean) {
  }
}

export class CoreFiltersChangedAction implements Action {
  readonly type = DntEventsListActionTypes.CoreFiltersChanged;

  constructor(public readonly payload: DntPrimaryFilter) {
  }
}

export class ExportReportRequestedAction implements Action {
  readonly type = DntEventsListActionTypes.ExportReportRequested;

  constructor(public readonly payload: ExportMetadata) {
  }
}

export class FiltersClearedAction implements Action {
  readonly type = DntEventsListActionTypes.FiltersCleared;
}

export class ResetDntFiltersAction implements Action {
  readonly type = DntEventsListActionTypes.ResetFilters;
}
